/**
 * Parse a data de nascimento corretamente sem problemas de timezone
 * Formato esperado: "2000-11-16T00:00:00.000Z"
 * @param dateString - String de data ISO
 * @returns Date object com a data correta
 */
export const parseBirthdate = (dateString: string): Date => {
  // Parse apenas a parte da data (YYYY-MM-DD) para evitar problemas de timezone
  const dateParts = dateString.split('T')[0].split('-');
  return new Date(
    parseInt(dateParts[0]), 
    parseInt(dateParts[1]) - 1, 
    parseInt(dateParts[2])
  );
};

/**
 * Formata a data de nascimento no formato brasileiro
 * @param dateString - String de data ISO
 * @param options - Opções de formatação (opcional)
 * @returns Data formatada
 */
export const formatBirthdate = (
  dateString: string, 
  options?: Intl.DateTimeFormatOptions
): string => {
  const date = parseBirthdate(dateString);
  const defaultOptions: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  };
  return date.toLocaleDateString('pt-BR', options || defaultOptions);
};
